import React from 'react';

const TableFooter = ({
  itemKey,
  tbodyStyle,
  lastRow,
  renderAddNote,
  handleCheckboxChange,
  markForExport
}) => {
  return (
    <tbody style={tbodyStyle}>
      <tr style={lastRow}>
        {renderAddNote(itemKey)}
        <td>
          <label style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            fontStyle: 'italic', 
            color: '#526666', 
            margin: '2px' 
          }}>
            <span
              onClick={() => handleCheckboxChange(itemKey)}
              style={{
                display: 'inline-block',
                width: '16px',
                height: '16px',
                marginRight: '8px',
                border: '2px solid #526666',
                borderRadius: '4px',
                backgroundColor: markForExport.has(itemKey)
                  ? '#526666'
                  : 'transparent',
                cursor: 'pointer',
                position: 'relative',
                padding: '0 2px'
              }}
            >
              {markForExport.has(itemKey) && (
                <span
                  style={{
                    position: 'absolute',
                    top: '-8px',
                    left: '0px',
                    fontSize: '24px',
                    color: 'white',
                    padding: '0 0 0 2px',
                    margin: '0'
                  }}
                >
                  ✔
                </span>
              )}
            </span>
            Mark For Export
          </label>
        </td>
      </tr>
    </tbody>
  );
};

export default TableFooter;
